import React from 'react';
import styles from '../DailyTrainingPage.module.css';

/**
 * LoadingState component for DailyTrainingPage
 * 
 * Displays a loading message with skeleton UI while the training session data is loading.
 * Uses a consistent skeleton UI pattern with test IDs for reliable testing.
 */
const LoadingState: React.FC = () => (
  <div className={styles.container}>
    <h2>Daily Training</h2>
    <div className={styles.loadingStateEnhanced} data-testid="loading-state">
      <div className={styles.loadingMessage}>Loading daily training session...</div>
      
      {/* Skeleton for progress bar */}
      <div className={styles.skeletonProgress}>
        <div className={styles.skeletonProgressBar} data-testid="skeleton-progress-bar"></div>
      </div>
      
      {/* Skeleton for challenge container */}
      <div className={styles.skeletonChallenge} data-testid="skeleton-challenge">
        <div className={styles.skeletonHeader}></div>
        <div className={styles.skeletonContent}>
          <div className={styles.skeletonBoard} data-testid="skeleton-board"></div>
          <div className={styles.skeletonControls}>
            <div className={styles.skeletonButton} data-testid="skeleton-button-1"></div>
            <div className={styles.skeletonButton} data-testid="skeleton-button-2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default React.memo(LoadingState); 